const doc = [({"en":({"haya_select":({"nothing_selected":"Nothing selected.", "search_dot_dot_dot":"Search...", "no_options_found":"No options found."})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;